<template>
  <section class="password-section">
    <div class="password-container" v-if="hasReady">
      <div class="modal-content portal_student">
        <div class="info-user-password">
          <div class="modal-body double">
            <div class="form-group form-user-site-password">
              <div class="form-label">
                <label>
                  Senha Atual
                  <v-tooltip text="Campo obrigatório" location="top">
                    <template v-slot:activator="{ props }">
                      <fa v-bind="props" icon="fa-solid fa-circle-check" style="color: #4CAF50;"></fa>
                    </template>
                  </v-tooltip>
                </label>
              </div>
              <div class="form-input">
                <input v-model="oldPassword" type="password" class="form-control" placeholder="Senha Atual" autocomplete="current-password">
              </div>
            </div>
          </div>
          <div class="modal-body double">
            <div class="form-group form-user-site-password">
              <div class="form-label">
                <label>
                  Nova senha
                  <v-tooltip text="Campo obrigatório" location="top">
                    <template v-slot:activator="{ props }">
                      <fa v-bind="props" icon="fa-solid fa-circle-check" style="color: #4CAF50;"></fa>
                    </template>
                  </v-tooltip>
                </label>
              </div>
              <div class="form-input">
                <input v-model="password" type="password" class="form-control" placeholder="Nova senha" autocomplete="new-password">
              </div>
            </div>
            <div class="form-group form-user-site-password">
              <div class="form-label">
                <label>
                  Confirme a nova senha
                  <v-tooltip text="Campo obrigatório" location="top">
                    <template v-slot:activator="{ props }">
                      <fa v-bind="props" icon="fa-solid fa-circle-check" style="color: #4CAF50;"></fa>
                    </template>
                  </v-tooltip>
                </label>
              </div>
              <div class="form-input">
                <input v-model="rePassword" type="password" class="form-control" placeholder="Confirmar nova senha" autocomplete="new-password">
              </div>
            </div>
          </div>
        </div>
        <div class="actionsSave2">
          <button class="btnSave" @click="updatePassword">Salvar</button>
        </div>
      </div>
    </div>
    <Loader :hasReady="hasReady" />
    <v-dialog v-model="dialog" max-width="290">
      <v-card class="password-card">
        <v-card-title class="headline">Sucesso</v-card-title>
        <v-card-text>Senha alterada com sucesso</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import { mapState } from 'vuex';
import User from '@/utils/Weflix/user';
import Loader from '@/components/Weflix/Loader';
export default {
    data() {
        return {
            oldPassword: '',
            password: '',
            rePassword: '',
            hasReady: true,
            dialog: false,
        }
    },
    components: {
        Loader
    },
    computed: {
        ...mapState(['token','userPortalWeflix'])
    },
    methods: {
       async updatePassword(){
        if(this.password != this.rePassword ){
            alert('As senhas não conferem');
            return;
        }
        this.hasReady = false;
        const payload = {
            oldPassword: this.oldPassword,
            newPassword: this.password,
        }
        try {
            const response = await User.changePassword(payload, this.userPortalWeflix.acessToken? this.userPortalWeflix.acessToken : this.token);
            this.hasReady = true;
            this.dialog = true;
        } catch (error) {
            console.error(error);
            this.hasReady = true;
        }
    }  
    },
}
</script>

<style scoped>
.password-section {
  background-color: #1d1d1d;
  padding: 30px 0;
  min-height: 100vh;
}

.password-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 16px;
}

.modal-content.portal_student {
  background-color: #1d1d1d !important;
  border-radius: 8px;
  box-shadow: none !important;
  padding: 30px 30px 10px 30px !important;
  width: 100%;
  max-width: 100%;
}

.info-user-password {
  width: 100%;
}

.form-group.form-user-site-password {
  margin-bottom: 20px;
}

.form-label label {
  color: #ffffff !important;
  font-size: 14px;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
}

.form-control {
  background-color: #2d2d2d !important;
  border: 1px solid #404040 !important;
  color: #ffffff !important;
  padding: 10px 15px;
  border-radius: 6px;
  width: 100%;
  font-size: 16px;
}

.form-control:focus {
  border-color: #505050 !important;
  box-shadow: 0 0 0 2px rgba(80, 80, 80, 0.25);
}

.form-control::placeholder {
  color: #ffffff;
  opacity: 1;
}

.actionsSave2 {
  text-align: right;
  margin: 10px 6px;
}

.btnSave {
  background-color: #000000 !important;
  color: white !important;
  padding: 10px 25px;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  transition: background-color 0.3s ease;
  width: 150px;
  font-size: 18px;
  border: 2px solid #ddd;
}

.btnSave:hover {
  background-color: #45a049 !important;
}

.v-dialog .v-card {
  background-color: #2d2d2d !important;
  color: white !important;
}

.v-card-title.headline {
  display: none !important;
}

.v-card-text {
  color: #e0e0e0 !important;
}

.v-btn {
  background-color: #4CAF50 !important;
  color: white !important;
}

@media (max-width: 600px) {
  .password-container {
    max-width: 100%;
    padding: 0 4px;
  }
  .modal-content.portal_student {
    padding: 15px 5px 5px 5px !important;
    border-radius: 0;
  }
  .actionsSave2 {
    margin: 10px 0;
  }
  .btnSave {
    width: 100%;
    font-size: 16px;
    padding: 10px 0;
  }
  .form-control {
    font-size: 15px;
    padding: 10px 10px;
  }
  .form-label label {
    font-size: 13px;
  }
}

.description span svg path {
    fill: #808080 !important;
}

.v-slider-track__fill {
    background-color: #4CAF50 !important;
}

.v-slider-thumb__surface.elevation-2 {
    background-color: #45a049 !important;
}

.v-slider-thumb__label {
    background-color: #4CAF50 !important;
}

.password-card.v-card.v-theme--light.v-card--density-default.v-card--variant-elevated {
    background-color: #2d2d2d !important;
    color: white !important;
    padding: 15px 30px !important;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

.warning {
    background-color: #2d2d2d;
    color: #e0e0e0;
    border: 1px solid #404040;
    padding: 10px 15px;
    border-radius: 6px;
}
.form-control::placeholder {
  color: white !important;
  opacity: 1; /* Garante que o branco fique visível */
}
</style>